import { JOOR_PAY_ORDERS_PREFIX as FEATURE_PREFIX } from 'featurePrefix.ids'

const ACTION_BAR_PREFIX = 'action-bar'
const ORDERS_TABLE_PREFIX = 'orders-table'

export const ActionBarIds = {
  SearchBar: `${FEATURE_PREFIX}__${ACTION_BAR_PREFIX}__search-bar`,
  ActionsMenu: `${FEATURE_PREFIX}__${ACTION_BAR_PREFIX}__actions-menu`,
  FiltersMenu: `${FEATURE_PREFIX}__${ACTION_BAR_PREFIX}__filters-menu`,
  ExportTableButton: `${FEATURE_PREFIX}__${ACTION_BAR_PREFIX}__export-table-button`,
} as const

export const OrdersTableIds = {
  ActionsMenu: `${FEATURE_PREFIX}__${ORDERS_TABLE_PREFIX}__actions-menu`,
} as const
